import React, {Component} from "react";
import actions from '../actions';
import {connect} from 'react-redux';
import VisitorsPage from '../components/VisitorsPage';
import ObjectUtils from '../../../baseApp/shared/utils/ObjectUtils';

class VisitorsPageContainer extends Component {
    constructor() {
        super();
        this.state = {
            universalSearchField: "",
            alert: {
                show: false
            },
            searchFieldsValues: {
                name: {
                    value: ""
                },
                email: {
                    value: ""
                },
                companyName: {
                    value: ""
                }
            }
        }
    };

    componentDidMount() {
        this.fetchData();
    };

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        let {
            searchFieldsValues,
            universalSearchField
        } = this.state;

        if(currentPage === undefined){
            if(this.props.location.state?.searchFieldsData !== undefined){
                searchFieldsValues =  this.props.location.state.searchFieldsData;
                this.handleSearchFieldValuesChange(searchFieldsValues);
            }
            if(this.props.location.state?.universalSearchField !== undefined ){
                universalSearchField = this.props.location.state.universalSearchField;
                this.handleUniversalSearchFieldChange(universalSearchField);
            }
        }

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                {...acc} : {...acc, [keyValuePair[0]]: keyValuePair[1].value}
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }

        this.props.searchVisitors({
            ...filter,
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: sortProperty,
            sortDirection: sortDirection,
        })
    };

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    };

    handleSearchFieldValuesChange = (value) => {
        this.setState({
            searchFieldsValues: value
        })
    };

    handleUniversalSearchFieldChange = (value) => {
        this.setState({
            universalSearchField: value
        })
    };

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    handleSearchClear = () => {
        this.setState({
            universalSearchField: "",
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    };

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    };

    handleSortChanged = newSort => {
        const {
            table:  {
                pageNumber,
                pageSize
            }
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    };

    handleRowClicked = visitor => {
        this.props.history.push({
            pathname: '/visitors/' + visitor.id, 
            state: { searchFieldsData : this.state.searchFieldsValues, universalSearchField: this.state.universalSearchField }
        });
    };

    render() {
        const { searchFieldsValues, universalSearchField, alert } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },
            loadingCheckoutRequest
        } = this.props;
        return (
                <VisitorsPage
                    alert={{
                        ...alert,
                        loading: loadingCheckoutRequest
                    }}
                    searchFieldsValues={searchFieldsValues}
                    universalSearchField={universalSearchField}

                    handleSearchFieldChange={this.handleSearchFieldChange}
                    handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                    handleSearchSubmit={this.handleSearchSubmit}
                    handleSearchClear={this.handleSearchClear}
                    handleSortChanged={this.handleSortChanged}

                    data={data}
                    sort={sort}
                    totalElements={totalElements}
                    pages={pages}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    onPageChange={this.onPageChange}
                    onRowClick={this.handleRowClicked}
                    onPageSizeChange={this.onPageSizeChange}
                />
        );
    }
}

const mapStateToProps = ({ visitorsReducer }) => {
    return {
        table: visitorsReducer.table,
        loadingCheckoutRequest: visitorsReducer.loadingCheckoutRequest,
        checkOut: visitorsReducer.checkOut,
    };
};

const mapDispatchToProps = {
    searchVisitors: actions.searchVisitors,
    checkOutSelectEntries: actions.checkOutSelectEntries,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VisitorsPageContainer);
